import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import SoundToggle from './SoundToggle';
import MusicToggle from './MusicToggle';

interface GameContainerProps {
  children: React.ReactNode;
  isMenuOpen: boolean;
  hasLost: boolean;
  isAbandoned?: boolean;
  className?: string;
}

const GameContainer = forwardRef<HTMLDivElement, GameContainerProps>(
  (
    { children, isMenuOpen, hasLost, isAbandoned = false, className = '' },
    ref
  ) => {
    const shouldHide = isMenuOpen || hasLost || isAbandoned;

    return (
      <motion.div
        ref={ref}
        className={`game-content w-full h-full flex flex-col relative ${className}`}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: shouldHide ? 0 : 1, y: shouldHide ? 20 : 0 }}
        transition={{ duration: 0.3 }}
        style={{ pointerEvents: shouldHide ? 'none' : 'auto' }}
      >
        {children}
      </motion.div>
    );
  }
);

export default GameContainer;
